import { AxiosResponse } from 'axios';
import {
  deleteExternalUserById,
  getExternalUsers,
  getExternalUserById,
  getCompaniesByExternalUser,
  updateExternalUserById,
} from '../ExternalUsers';
import {
  deleteInternalUserById,
  getInternalUsers,
  getInternalUserById,
  getCompaniesByInternalUser,
  updateInternalUserById,
} from '../InternalUsers';
import { GetResponseUsers, UserCompanies } from './types';
import { User, GenericUser, Pagination } from '~/types';
import api from '~/utils/api';

export async function getUsers(
  page: number,
  search = '',
  pageSize: number,
): Promise<GetResponseUsers> {
  const internalUsers = await getInternalUsers(
    page,
    Math.round(pageSize / 2),
    search,
  );
  const externalUsers = await getExternalUsers(
    page,
    Math.round(pageSize / 2),
    search,
  );

  const users = [...internalUsers.users, ...externalUsers.users];
  const totalCount = internalUsers.totalCount + externalUsers.totalCount;

  return {
    users,
    totalCount,
  };
}

export async function getGenericUsers(
  page: number,
  search = '',
  pageSize: number,
): Promise<Pagination<GenericUser>> {
  const { data } = await api.get<Pagination<GenericUser>>('/users/list', {
    params: {
      page,
      size: pageSize,
      ...(search ? { search } : {}),
    },
  });

  return {
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results,
  };
}

export async function getUsersByGroup(
  idGroup: string,
  page: number,
  pageSize: number,
): Promise<Pagination<GenericUser>> {
  const { data } = await api.get<Pagination<GenericUser>>('/users/list', {
    params: {
      page,
      size: pageSize,
      id_grupoeconomico: idGroup,
    },
  });

  return data;
}

export async function deleteUser(user: User): Promise<AxiosResponse<any>> {
  if (user.type === 'Cliente' || user.type === 'EXTERNO') {
    return deleteExternalUserById(user.id);
  }
  return deleteInternalUserById(user.id);
}

export async function getUserById(id: number, type: string): Promise<User> {
  if (type === 'Cliente' || type === 'EXTERNO') {
    const response = await getExternalUserById(id);
    return response;
  }
  const response = await getInternalUserById(id);
  return response;
}

export async function getCompaniesByUser(
  id: number,
  type: string,
): Promise<UserCompanies> {
  if (type === 'Cliente' || type === 'EXTERNO') {
    const response = await getCompaniesByExternalUser(id);
    return response;
  }
  const response = await getCompaniesByInternalUser(id);
  return response;
}

export async function updateUserById(
  id: number,
  type: string,
  data: any,
): Promise<any> {
  if (type === 'Cliente' || type === 'EXTERNO') {
    const response = await updateExternalUserById(id, data);
    return response;
  }
  const response = await updateInternalUserById(id, data);
  return response;
}

export async function checkUserByEmail(data: { email: string }): Promise<any> {
  return api.post('/users/check', data);
}

export async function getUsersXlsx(search = ''): Promise<AxiosResponse<any>> {
  const url = '/users/xlsx';
  return api.get(url, {
    params: {
      ...(search && { search }),
    },
    headers: {
      'Content-Type': 'application/xlsx',
    },
    responseType: 'blob' as 'json',
  });
}

export async function getUsersByGroupXlsx(
  params: Record<string, string | number | boolean>,
): Promise<AxiosResponse<Blob>> {
  const url = '/users/export_users_by_group';
  return api.get(url, {
    params,
    headers: {
      'Content-Type': 'application/xlsx',
    },
    responseType: 'blob',
  });
}
